@if (model?.data) {
<div class="flex-column"
     style="height: 100%;">
     <!-- images -->
     <href [link]="model.data.url">
          <img class="w-12"
               [dfImage]="model.data.image"
               [alt]="model.data.name"
               [ratio]="'3/4'">
     </href>
     <div class="flex-grow">
          <a class="block p-t-3 left"
             [sizeClass]="'XL: p1, MS:p2'"
             [routerLink]="model.data.url">{{model.data.name}}</a>
     </div>
</div>
}